import PageTitle from '@/components/Admin/PageTitle';
import React, { useState } from 'react';
import { styled } from 'styled-components';

import { colors } from '@/constants/colors';
import SectionTitle from '@/components/Admin/SectionTitle';
import Btn from '@/components/Admin/UI/Btn';
import OptionBtn from '@/components/Admin/UI/OptionBtn';
import { useUIStore } from '@/store/useUIStore';
import { useQuery } from '@tanstack/react-query';
import {
   fetchStoreWithSubscription,
   StoreSubscription,
} from '@/api/subscription';
import { TableStore } from './Stores';

interface Props {
   sample: string;
}

export type SelectedStore = {
   id: string;
   name: string;
   duration: number;
   pro: boolean;
};

// type StoreWithSubscription = {
//    id: string;
//    name: string;
//    duration: number;
//    pro: boolean;
// };

const Subscription = () => {
   const { handleShow, refresh } = useUIStore();
   const [selectedStore, setSelectedStore] = useState<string | null>(null);

   const stores = [
      {
         id: '2',
         name: 'Vendo Two',
         duration: '26 days left',
         pro: true,
      },
      {
         id: '1',
         name: 'Vendo One',
         duration: '-',
         pro: false,
      },

      {
         id: '3',
         name: 'Vendo Three',
         duration: '-',
         pro: false,
      },
   ];

   const {
      data: storeResponse,
      isLoading,
      error,
   } = useQuery({
      queryKey: ['stores-subscription', refresh],
      queryFn: fetchStoreWithSubscription,
   });

   // Transform the API data to match the table format
   const transformedData =
      storeResponse?.result?.map((store) => ({
         ...store,
         id: store.id,
         name: store.name,
         duration: store.duration,
         pro: store.pro,
      })) || [];

   // console.log(`-----transformedData`, transformedData);

   const handleStoreClick = (storeId: string) => {
      setSelectedStore(storeId);
   };

   // console.log(`xxxx`, selectedStore);
   const handleSubscribeStore = (item: SelectedStore) => {
      handleShow({
         template: 'subscribe-store',
         title: item.pro
            ? `Extend subscription for ${item.name}`
            : `You are about to subscribe ${item.name}`,
         windowType: 'desktop',
         data: item,
      });
   };
   return (
      <Wrapper>
         <PageTitle title="Subscription" actions={[]} />

         <Fees>
            <FeesContent>
               <ItemLabels>
                  <ContentTitle>Fees</ContentTitle>

                  <ItemContent>
                     <ItemContentLabel>
                        Platform Processing Fee:
                     </ItemContentLabel>
                     <ItemContentLabel>Xendit Processing Fee:</ItemContentLabel>
                     <ItemContentLabel>
                        Xendit Disbursement Fee:
                     </ItemContentLabel>
                  </ItemContent>
               </ItemLabels>

               <Item>
                  <TitleBadge $pro={true}>PRO PLAN</TitleBadge>

                  <ItemContent>
                     <ItemContentValue>0%</ItemContentValue>
                     <ItemContentValue>2.3% + VAT</ItemContentValue>
                     <ItemContentValue>₱15 / payout</ItemContentValue>
                  </ItemContent>
               </Item>

               <Item>
                  <TitleBadge $pro={false}>FREE PLAN</TitleBadge>

                  <ItemContent>
                     <ItemContentValue>20%</ItemContentValue>
                     <ItemContentValue>2.3% + VAT</ItemContentValue>
                     <ItemContentValue>₱15 / payout</ItemContentValue>
                  </ItemContent>
               </Item>
            </FeesContent>

            <MobileFees>
               <MobilePlanCard $pro={true}>
                  <MobilePlanHead>
                     <TitleBadge $pro={true}>PRO</TitleBadge>
                     <MobilePlanSub>Best for scaling</MobilePlanSub>
                  </MobilePlanHead>
                  <MobileFeeRow>
                     <span>Platform Fee</span>
                     <strong>0%</strong>
                  </MobileFeeRow>
                  <MobileFeeRow>
                     <span>Payment Gateway Fee</span>
                     <strong>2.3% + VAT</strong>
                  </MobileFeeRow>
                  <MobileFeeRow>
                     <span>Disbursement</span>
                     <strong>₱15 / payout</strong>
                  </MobileFeeRow>
               </MobilePlanCard>
               <MobilePlanCard $pro={false}>
                  <MobilePlanHead>
                     <TitleBadge $pro={false}>FREE</TitleBadge>
                     <MobilePlanSub>Default plan</MobilePlanSub>
                  </MobilePlanHead>
                  <MobileFeeRow>
                     <span>Platform Fee</span>
                     <strong>20%</strong>
                  </MobileFeeRow>
                  <MobileFeeRow>
                     <span>Payment Gateway Fee</span>
                     <strong>2.3% + VAT</strong>
                  </MobileFeeRow>
                  <MobileFeeRow>
                     <span>Disbursement</span>
                     <strong>₱15 / payout</strong>
                  </MobileFeeRow>
               </MobilePlanCard>
            </MobileFees>
         </Fees>

         <Stores>
            {/* <SectionTitle title="Stores" /> */}
            <ContentTitle>Stores</ContentTitle>

            <StoresContent>
               {transformedData.map((item, index) => (
                  <StoresItem
                     key={index}
                     onClick={() => handleStoreClick(item.id)}
                     $selected={item.id === selectedStore}
                  >
                     <StoreItemMain>
                        {!item.pro ? (
                           <OptionBtn active={item.id === selectedStore} />
                        ) : (
                           <OptionBtnDisabled />
                        )}

                        <TitleBadge $pro={item.pro}>
                           {item.pro ? 'PRO' : 'FREE'}
                        </TitleBadge>
                        <StoreName>{item.name}</StoreName>
                     </StoreItemMain>
                     <StoreItemAction>
                        <StoreDuration>
                           {item.duration === 0
                              ? '-'
                              : `${item.duration} days left`}
                        </StoreDuration>

                        {item.pro ? (
                           <div onClick={() => handleSubscribeStore(item)}>
                              <Btn
                                 title="Extend"
                                 type="normal"
                                 textcolor={colors.WHITE}
                                 bgcolor={colors.PRIMARY}
                                 size="small"
                                 onClick={() => {}}
                              />
                           </div>
                        ) : (
                           <div onClick={() => handleSubscribeStore(item)}>
                              <Btn
                                 title="Upgrade"
                                 type="normal"
                                 textcolor={colors.WHITE}
                                 bgcolor={colors.PRIMARY}
                                 size="small"
                                 onClick={() => {}}
                              />
                           </div>
                        )}
                     </StoreItemAction>
                  </StoresItem>
               ))}
            </StoresContent>
         </Stores>
      </Wrapper>
   );
};

export default Subscription;

const Wrapper = styled.div`
   /* font-family: 'Inter', sans-serif; */
`;

const Fees = styled.div``;

const FeesContent = styled.div`
   padding: 1rem;
   border: 1px solid ${colors.GRAY14};
   border-radius: 8px;
   display: grid;
   grid-template-columns: 1fr 1fr 1fr;
   gap: 1rem;

   @media (max-width: 768px) {
      display: none;
   }
`;

const MobileFees = styled.div`
   display: none;
   @media (max-width: 768px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      padding: 0 12px;
   }
`;

const MobilePlanCard = styled.div<{ $pro: boolean }>`
   border: 1px solid
      ${({ $pro }) => ($pro ? colors.PRIMARY20 : colors.GRAY13)};
   background: ${({ $pro }) => ($pro ? 'rgba(55,96,249,0.08)' : 'var(--app-surface)')};
   border-radius: 14px;
   padding: 12px;
   display: flex;
   flex-direction: column;
   gap: 6px;
`;

const MobilePlanHead = styled.div`
   display: flex;
   flex-direction: column;
   align-items: flex-start;
   gap: 4px;
   margin-bottom: 4px;
`;

const MobilePlanSub = styled.span`
   font-size: 10px;
   color: ${colors.GRAY5};
   text-transform: uppercase;
   letter-spacing: 0.04em;
`;

const MobileFeeRow = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   font-size: 12px;
   color: ${colors.GRAY5};
   padding: 4px 0;
   border-top: 1px dashed ${colors.GRAY13};
   strong {
      color: ${colors.MAIN_DARK90};
      font-weight: 600;
   }
`;

const ItemLabels = styled.div`
    @media (max-width: 768px) {
      display: none;
   }
`;
const Item = styled.div``;

const ContentTitle = styled.p`
   font-size: 1.2rem;
   font-weight: 600;
`;

const ItemContent = styled.div`
   margin-top: 1rem;
`;

const ItemContentLabel = styled.p`
   color: ${colors.GRAY4};
   font-size: 14px;
   margin-bottom: 5px;
`;
const ItemContentValue = styled.p`
   font-size: 14px;
   color: ${colors.GRAY7};
   margin-bottom: 5px;
`;

const StoresContent = styled.div`
   margin-top: 1rem;
`;

const StoresItem = styled.div<{ $selected: boolean }>`
   border: ${({ $selected }) =>
      $selected
         ? `1px solid ${colors.PRIMARY20}`
         : `1px solid ${colors.GRAY14}`};
   border-radius: 8px;
   padding: 1rem;
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 10px;
   cursor: pointer;
   @media (max-width: 768px) {
      padding: 10px 12px;
      border-radius: 12px;
      margin-bottom: 8px;
      gap: 10px;
   }
`;

const StoreItemMain = styled.div`
   display: flex;
   align-items: center;
   gap: 1rem;
   @media (max-width: 768px) {
      gap: 8px;
      flex: 1;
      min-width: 0;
   }
`;

const StoreItemAction = styled.div`
   display: flex;
   align-items: center;
   gap: 3rem;

   @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-end;
      gap: 4px;
   }
`;

const StoreName = styled.p`
   font-weight: 600;
   @media (max-width: 768px) {
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
   }
`;

const StoreDuration = styled.p`
   font-size: 14px;
   color: ${colors.GRAY1};
   margin-bottom: 5px;
   @media (max-width: 768px) {
      font-size: 11px;
      margin-bottom: 0;
      color: ${colors.GRAY5};
   }
`;

const Stores = styled.div`
   margin-top: 1rem;
   @media (max-width: 768px) {
      margin-top: 14px;
      padding: 0 12px;
   }
`;

const OptionBtnDisabled = styled.div`
   width: 20px;
`;

const TitleBadge = styled.span<{
   $pro: boolean;
}>`
   font-size: 14px;
   border: 2px solid
      ${({ $pro }) => ($pro ? colors.PRIMARY50 : colors.SECONDARY)};
   border-radius: 4px;
   padding: 0.2rem 0.5rem;
   color: ${colors.PRIMARY};
   background: ${({ $pro }) => ($pro ? colors.PRIMARY20 : colors.SECONDARY)};
   font-weight: 600;
   @media (max-width: 768px) {
      font-size: 10px;
      padding: 2px 6px;
      border-width: 1px;
      letter-spacing: 0.04em;
   }
`;
